import styled from "styled-components";
import Select from "react-select";
import theme from "~/styles/theme";

export const BoxInput = styled.div`
  label {
    color: ${theme.palette.neutral.primary.key};
    font-size: 16px;
    line-height: 24px;
    display: block;
    margin-bottom: 8px;
    font-family: ${theme.typography.fontFamilyRegular};
    font-weight: 500;
  }
`;

export const SelectInput = styled(Select)`
  box-sizing: content-box;
  height: 48px;
  font-size: 16px;
  line-height: 24px;
  font-family: ${theme.typography.fontFamilyRegular};

  & > div {
    background-color: ${theme.palette.neutral.primary.light};
    border-radius: 8px;
  }

  svg {
    color: ${theme.palette.neutral.primary.key};
  }
`;
